import { GET_AREA_ADS } from '../types/area-ads'

export const getAreaAds = () => {
  return {
    type: GET_AREA_ADS,
  }
}
